import { useState, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, CircularProgress } from '@mui/material';
import { themes, getThemeFromUrl, ThemeNameContext } from '@/theme';
import { Header, Footer } from '@/components/layout';
import { HomePage, CompanyPage, ServicePage, KampoPage, ShichusuimeiPage, ContactPage, NotFoundPage } from '@/pages';
import type { ThemeName } from '@/types';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PageLoader = () => (
  <Box
    sx={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress size={32} sx={{ color: 'primary.main' }} />
  </Box>
);

const App = () => {
  const [themeName, setThemeName] = useState<ThemeName>(getThemeFromUrl);

  return (
    <ThemeNameContext.Provider value={{ themeName, setThemeName }}>
      <ThemeProvider theme={themes[themeName]}>
        <CssBaseline />
        <BrowserRouter>
          <ScrollToTop />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
            }}
          >
            <Header />
            <Box component="main" sx={{ flex: 1 }}>
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/company" element={<CompanyPage />} />
                  <Route path="/service" element={<ServicePage />} />
                  <Route path="/kampo" element={<KampoPage />} />
                  <Route path="/shichusuimei" element={<ShichusuimeiPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </Suspense>
            </Box>
            <Footer />
          </Box>
        </BrowserRouter>
      </ThemeProvider>
    </ThemeNameContext.Provider>
  );
};

export default App;
